import { distance, point } from '@turf/turf';
import type { PublicState } from '../../shared/protocol';
import { metersToFeet } from '../util/format';

/** v20 BOLT-097 — the seeker left the Freeze ring before it expired, so their
 *  question cards are locked until they walk back in. Prominent + non-dismissible
 *  (the server clears the lock on re-entry). The distance-to-ring hint is derived
 *  from the seeker's OWN pin + their OWN ring — no hider data, no server round-trip. */
export function FreezeLockBanner({ state }: { state: PublicState }) {
  if (!state.freezeLocked || !state.freezeZone) return null;
  const pin = state.selfPin ?? state.seekerPin;
  const { anchor, radiusFt } = state.freezeZone;
  const outsideFt = pin
    ? Math.max(
        0,
        metersToFeet(distance(point([pin.lng, pin.lat]), point([anchor.lng, anchor.lat]), { units: 'meters' })) - radiusFt,
      )
    : null;
  return (
    <div className="stop-curse freeze-lock" data-testid="freeze-lock" role="alert">
      <div className="stop-curse__sign">
        <span className="stop-curse__word">LOCKED</span>
        <span className="stop-curse__sub">You must return to where you were frozen before continuing</span>
      </div>
      {outsideFt != null && (
        <span className="stop-curse__time" data-testid="freeze-distance">
          {outsideFt} ft
        </span>
      )}
    </div>
  );
}
